import * as React from "react";
import { forwardRef } from "react";
const SvgPipeCircleDark = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 19, viewBox: "0 0 21 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20.1568 18.3536C14.453 10.4995 6.43789 10.488 0.722656 18.3536V0.33392C6.4264 8.18806 14.4415 8.19956 20.1568 0.33392V18.3536Z", fill: "#464646" }));
const ForwardRef = forwardRef(SvgPipeCircleDark);
export default ForwardRef;
